import { createRouter, createWebHistory } from 'vue-router';
import ProductList from '../components/ProductList.vue';
import ProductDetail from '../components/ProductDetail.vue';
import ProductSearch from '../components/ProductSearch.vue';
import WutaishanPay from '../components/WutaishanPay.vue';

const routes = [
  {
    path: '/',
    name: 'ProductList',
    component: ProductList,
    meta: { title: '开心西游2008-仿官怀旧复古' }
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail,
    meta: { title: '产品详情' }
  },
  {
    path: '/wutaishan',
    name: 'WutaishanPay',
    component: WutaishanPay,
    meta: { title: '预约支付' }
  },
  {
    path: '/search',
    name: 'ProductSearch',
    component: ProductSearch,
    meta: { title: '订单查询' }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '梦幻西游2008-最好玩的梦幻私服';
  next();
});

export default router;